import React, { useEffect, useState } from "react";
import MutationStyle from "./mutation.module.css";
import {
  Button,
  Col,
  Form,
  Row,
  Select,
  InputNumber,
  Upload,
  Flex,
  Image,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ReactComponent as ExampleIcon } from "../../../assets/icon/信封打开.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/下载.svg";
import PartI from "./component/partI";
import http from "../../../utils/http";
import TextArea from "antd/es/input/TextArea";



function MutationInform() {
  const [form] = Form.useForm();
  const [fileContent, setFileContent] = useState("");
  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };
  useEffect(() => {
    form.setFieldsValue({
      group_1: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);
  const [fileContent2, setFileContent2] = useState("");
  const contentUpload2 = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent2(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };
  useEffect(() => {
    form.setFieldsValue({
      group_2: fileContent2,
    }); // 初始化时更新文本域的值
  }, [fileContent2]);
  const [imgSrc, setImgSrc] = useState("");
  const [HapLoading,setHopLoading]=useState(false)
  const [PdfSrc,setPdfSrc]=useState("")
  const [FileName,setFileName]=useState("")
  const onFinish = (value) => {
    setHopLoading(true)
    console.log(value);
    const newFormData = new FormData();
    const object = {
      group1: value.SN_1 == undefined ? value.group_1 : value.SN_1.file,
      group2: value.SN_2 == undefined ? value.group_2 : value.SN_2.file,
      chr: value.chr,
      start: value.start,
      end: value.end,
    };
    Object.keys(object).forEach((key) => {
      newFormData.append(key, object[key]);
    });
    http
      .post("/api/population/haplot/", newFormData)
      .then((res) => {
        console.log(res);
        setImgSrc(res.image);
        setPdfSrc(res.pdf)
        let TempleStr=value.chr+":"+value.start+"-"+value.end
        setFileName(TempleStr)
    setHopLoading(false)
      })
      .catch((err) => {
        console.log(err);
    setHopLoading(false)

      });
  };
  // 将 Base64 转换为 Blob 对象
function base64ToBlob(base64, contentType) {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
}
  // 触发文件下载
function downloadBase64File(base64, fileName, contentType) {
  const blob = base64ToBlob(base64, contentType);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName; // 设置下载的文件名
  document.body.appendChild(a);
  a.click(); // 触发点击事件，开始下载
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // 释放对象 URL
  }, 0);
}
  return (
    <div className={MutationStyle.MutationInform_app}>
      <div className={MutationStyle.MutationInform_Header}>
        <p>Mutation information query</p>
      </div>
      <PartI />
      <div className={MutationStyle.MutationInform_Header}>
        <p>Haplotype Analysis</p>
      </div>
      <div className={MutationStyle.MutationInform_FormDiv}>
        <Form
          style={{ width: "95%", margin: "10px auto" }}
          form={form}
          onFinish={onFinish}
        >
          <Row>
            <Col span={8}>
              <Flex vertical>
                <Form.Item
                  label={<span style={{ fontWeight: "bold" }}>Group 1</span>}
                  name="group_1"
                >
                  <TextArea
                    style={{ width: 300 }}
                    value={fileContent}
                    onChange={(e) => setFileContent(e.target.value)}
                    placeholder="Click to select a file or input the sample name for the group"
                  />
                </Form.Item>
                <Form.Item
                  name="SN_1"
                  style={{
                    width: "60%",
                  }}
                  label={<span style={{ color: "transparent" }}>Group 1</span>}
                  colon={false}
                >
                  <Upload
                    beforeUpload={contentUpload}
                    name="SN_1"
                    action="/upload.do"
                    onRemove={() => {
                      setFileContent("");
                    }}
                    listType="text"
                  >
                    <Button
                      style={{
                        border: "none",
                        padding: "0",
                        margin: "0",
                        background: "transparent",
                      }}
                      icon={<UploadOutlined />}
                    >
                      Click to upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex vertical>
                <Form.Item
                  label={<span style={{ fontWeight: "bold" }}>Group 2</span>}
                  name="group_2"
                >
                  <TextArea
                    style={{ width: 300 }}
                    value={fileContent}
                    onChange={(e) => setFileContent2(e.target.value)}
                    placeholder="Click to select file or drag file containing query
                      sequence(s) in FASTA format here..."
                  />
                </Form.Item>
                <Form.Item
                  name="SN_2"
                  style={{
                    width: "60%",
                  }}
                  label={<span style={{ color: "transparent" }}>Group 1</span>}
                  colon={false}
                >
                  <Upload
                    beforeUpload={contentUpload2}
                    name="SN_2"
                    action="/upload.do"
                    onRemove={() => {
                      setFileContent2("");
                    }}
                    listType="text"
                  >
                    <Button
                      style={{
                        border: "none",
                        padding: "0",
                        margin: "0",
                        background: "transparent",
                      }}
                      icon={<UploadOutlined />}
                    >
                      Click to upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Flex>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Chr</span>}
                name="chr"
              >
                <Select
                  style={{ width: 250 }}
                  options={[
                    {
                      key: "Chr01",
                      label: "Chr01",
                      value: "Chr01",
                    },
                    {
                      key: "Chr02",
                      label: "Chr02",
                      value: "Chr02",
                    },
                    {
                      key: "Chr03",
                      label: "Chr03",
                      value: "Chr03",
                    },
                    {
                      key: "Chr04",
                      label: "Chr04",
                      value: "Chr04",
                    },
                    {
                      key: "Chr05",
                      label: "Chr05",
                      value: "Chr05",
                    },
                    {
                      key: "Chr06",
                      label: "Chr06",
                      value: "Chr06",
                    },
                    {
                      key: "Chr07",
                      label: "Chr07",
                      value: "Chr07",
                    },
                    {
                      key: "Chr08",
                      label: "Chr08",
                      value: "Chr08",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Start</span>}
                name="start"
              >
                <InputNumber
                  min={1}
                  step={1}
                  style={{ width: 250 }}
                  stringMode={true}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>End</span>}
                name="end"
              >
                <InputNumber
                  min={1}
                  step={1}
                  style={{ width: 250 }}
                  stringMode={true}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Button
                onClick={() => {
                  const formval=form.getFieldsValue()
                  console.log(form.getFieldsValue());
                  http.get(`/api/population/seqd/?chr=${formval.chr}&start=${formval.start}&end=${formval.end}`)
                  .then(res=>{
                    // console.log(res);
                    // const blob = new Blob([res.data], { type: "application/octet-stream" });
                    const blob = new Blob([res], { type: "application/octet-stream" });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = `${formval.chr}.${formval.start}-${formval.end}.fa`;  // 设置下载文件名
                    link.click();  // 触发下载
                  })
                  .catch(err=>{})
                }}
              >
                DownLoad
              </Button>
            </Col>
          </Row>
          <Form.Item>
            <Button
              style={{ display: "flex", alignItems: "center", border: "none" }}
              onClick={() => {
                form.setFieldsValue({
                  chr: "Chr05",
                  start: "2098979",
                  end: "2117494",
                  group_1: `P337_56
P337_59
P337_60
P337_61
P337_62
P337_114
P337_115
P337_432
P337_543
P337_lotusU-655
P337_M50
P337_M61
P337_M64
P337_M65
P337_R01
`,
                  group_2: `P337_20
P337_21
P337_22
P337_23
P337_24
P337_26
P337_27
P337_30
P337_31
P337_32
P337_33
P337_35
P337_37
P337_38
P337_JX17-S1
`,
                });
              }}
            >
              {" "}
              <ExampleIcon width={20} />{" "}
              <span
                style={{
                  margin: "0 10px",
                  fontFamily: "SourceHanSansSC-regular",
                }}
              >
                example
              </span>
            </Button>
          </Form.Item>
          <Form.Item
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              style={{
                margin: "0 100px",
                width: "150px",
                background: "#076A09",
                border: "none",
                color: "white",
              }}
              htmlType="submit"
              loading={HapLoading}
            >
              Search
            </Button>
            <Button style={{ margin: "0 100px", width: "150px" }}>Reset</Button>
          </Form.Item>
        </Form>
      </div>
      <div style={{width:"95%",margin:"auto",display:"flex",alignItems:"flex-end",justifyContent:"flex-end"}}>
         <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "none",
                      margin: "0 10px",
                    }}
                    onClick={()=>{
                      downloadBase64File(PdfSrc,FileName,"application/pdf")
                    }}
                  >
                    <DownloadIcon width={20} />{" "}
                    <span
                      style={{
                        margin: "0 10px",
                        fontFamily: "SourceHanSansSC-regular",
                      }}
                    >
                      PDF
                    </span>
                  </Button>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Image
          src={`data:image/png;base64,${imgSrc || ""}`}
          width={800}
          alt=""
        />
      </div>
      <div style={{ height: "20px" }}></div>
    </div>
  );
}

export default MutationInform;
